import { PayloadAction, SliceCaseReducers, createSlice } from '@reduxjs/toolkit';
import { ICatalogItemState } from './types';
import { catalogItemReducerPath } from './const';

type CatalogItemType = ICatalogItemState | null | undefined;
const initState: CatalogItemType = null;

export const catalogItemSlice = createSlice<CatalogItemType, SliceCaseReducers<CatalogItemType>, string>({
  name: catalogItemReducerPath,
  initialState: initState,
  reducers: {
    setCatalogItem(_state, action: PayloadAction<CatalogItemType>) {
      return action.payload || null;
    },
  },
});

export const catalogItemConfig = {
  [catalogItemReducerPath]: catalogItemSlice.reducer,
};
